import styled from 'styled-components';
import { darken } from 'polished';

export const VideosContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const VideoButton = styled.button`
  width: 100%;
  padding: 10px 20px;
  cursor: pointer;
  background: #fff;
  color: ${props => (props.selected ? '#62B0F3' : '#000')};
  border-radius: 6px;
  font-family: Roboto;
  border: ${props =>
    props.selected ? '1px solid #62B0F3' : '1px solid lightgray'};

  &:hover {
    background: ${darken(0.03, '#fff')};
  }
`;
